import dayjs from "dayjs";

export const formatDispatchDate = (value) => {
  if (!value) return "--";
  return dayjs(value).format("DD-MM-YYYY");
};

export const formatDispatchDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return "--";
  return `${formatDispatchDate(startDate)} to ${formatDispatchDate(endDate)}`;
};

export const getDefaultDispatchDateRange = () => {
  const start = dayjs();
  const end = start.add(29, "day");
  return {
    start_date: start.format("YYYY-MM-DD"),
    end_date: end.format("YYYY-MM-DD"),
  };
};

export const getDispatchDaysCount = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  return dayjs(endDate).diff(dayjs(startDate), "day") + 1;
};

export const getDailyTargetQty = (totalQty, startDate, endDate) => {
  const days = getDispatchDaysCount(startDate, endDate);
  if (!days || !totalQty) return 0;
  return Math.round((Number(totalQty) / days) * 100) / 100;
};
